import { useGamesStore } from '../../store';

export const useGetIsLiveRtpGamesLoaded = () => {
  return useGamesStore(
    (store) => store.dynamicCategories?.liveRtpGames?.isLoaded
  );
};
